// Arrow function for transitionend handler (stored as a reference)
const onCounterTransitionEnd = () => {
  if (statisticAnimation && typeof statisticAnimation.pauseResume === 'function') {
    statisticAnimation.pauseResume();
  }
};

// Arrow function to check if an element is in the viewport
const isCounterInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
};

// Arrow function to handle the counter logic
const handleCounterElements = () => {
  document.querySelectorAll('[data-counter]').forEach((element) => {
    if (isCounterInViewport(element) && !element.classList.contains('is-done')) {
      element.classList.add('is-done');

      const counterValue = element.getAttribute('data-counter');
      const separator = element.getAttribute('data-separator');
      const decimal = element.getAttribute('data-decimal');
      const decimalValue = counterValue.includes('.') ? counterValue.split('.')[1] : '';
      const decimalPlaces = decimalValue.length;

      const c = new countUp.CountUp(element, counterValue, {
        separator,
        decimal,
        decimalPlaces,
      });

      c.start();

      element.addEventListener('transitionend', onCounterTransitionEnd, true);
    } else if (!isCounterInViewport(element)) {
      element.removeEventListener('transitionend', onCounterTransitionEnd, true);
    }
  });
};

// Attach scroll and load event listeners
window.addEventListener('load', handleCounterElements);
window.addEventListener('scroll', handleCounterElements);

// *******************************************************************************
// Open Modal
// *******************************************************************************

const togglePopupClass = (ele, toggle) => {
  const parentElem = ele.target.closest('.branch-locations__popup');
  parentElem.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
  ele.preventDefault();
};

attachEvent('.branch-locations__popup-btn', 'click', (ev) => {
  if (windowWidth() < breakpointSm) {
    togglePopupClass(ev, true);
  }
});

// *******************************************************************************
// Close Modal
// *******************************************************************************

attachEvent('.branch-locations__popup-close, .branch-locations__popup-overlay', 'click', (ev) => {
  if (windowWidth() < breakpointSm) {
    togglePopupClass(ev, false);
  }
});

// *******************************************************************************
// Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalEle = document.querySelector('.branch-locations__popup.is-open-modal');

    if (modalEle) {
      modalEle.classList.remove('is-open-modal');
      toggleBodyScrollLock(false);
    }
  }
});
